export default __webpack_public_path__ + "static/media/ProductDark.6d0deca1.svg";